import { SVGProps } from 'react';

interface MoonIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

/**
 * Moon Icon
 *
 * Represents dark mode in the theme toggle.
 */
export function MoonIcon({ size = 24, ...props }: MoonIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="17" cy="7" r="1" fill="currentColor" />
      <circle cx="19" cy="11" r="0.5" fill="currentColor" />
      <circle cx="15" cy="5" r="0.5" fill="currentColor" />
    </svg>
  );
}
